import { Occupation } from "./v1";

export type OccupationV1Type = keyof typeof Occupation;
export type OccupationType = OccupationV1Type;
